/** Classes for a router Link that reads as a primary Button (Link cannot take Button's props). */
export const ACTION_LINK_CLASS =
  "inline-flex min-h-11 items-center justify-center rounded-control bg-blue px-4 font-semibold text-white transition-colors duration-[120ms] hover:bg-blue-deep";
